<script lang="ts">
    import MagnifyIcon from "svelte-material-icons/Magnify.svelte"
    import { optionsConf } from "../../config"
    import { openOptionsChooserOverlay, openRalChooserOverlay } from "../../store"
    import LightboxGallery from "../widgets/LightboxGallery.svelte"
    import Tooltip from "../widgets/Tooltip.svelte"

    export let product: Product
    export let alt: string
    export let activeImage: ImageEntry

    $: image = activeImage ? activeImage.file?.src : product?.images?.length ? product?.images[0].file?.src : undefined
    $: quboMatt = product.code.toString().match(/^23/) ? " matt" : ""

    let gallery: ImageEntry[]
    let tooltip_active: {
        [key: string]: boolean
    } = {}
    export let activeColor: RALColor = undefined
    export let activeOptions: string[] = undefined

    export let imageColorMismatch: boolean = false
    console.log("productimage,", product.images)
    $: {
        imageColorMismatch = false
        if (activeColor) {
            const filename = image?.replace(/(.*\/)*/, "")
            const match = filename?.match(/^[^_]+_(\d{4})(_|\.)/)
            if (match && match[1] && match[1] != activeColor?.RAL) {
                // filename with color code, but other color
                imageColorMismatch = true
            }
        }
    }

    // Mouse move hover Zoom Function
    let imagePosition: HTMLDivElement
    let mousePosition = { x: 0, y: 0 }

    function handleMousemove(event: { clientX: number; clientY: number }) {
        var relativeX = imagePosition.offsetLeft
        var relativeY = imagePosition.offsetTop
        // var relativeWidth = imagePosition.width / 2
        // var relativeHeight = imagePosition.height / 2
        // relativeX = relativeX + relativeWidth
        // relativeY = relativeY + relativeHeight
        mousePosition.x = event.clientX - relativeX
        mousePosition.y = event.clientY - relativeY
    }

    function openOChooser() {
        if (typeof $openOptionsChooserOverlay == "function") {
            $openOptionsChooserOverlay()
        }
    }

    let includedOptions: string[] = []
    $: {
        includedOptions = []
        const confParams = product?.config_params
        if (confParams) {
            for (let key in optionsConf) {
                const inConfs = optionsConf[key]?.includedIn
                if (inConfs) {
                    for (let i = 0; i < inConfs.length; i++) {
                        let isIn = true
                        for (let opt in inConfs[i]) {
                            if (inConfs[i][opt] !== confParams[opt]) {
                                isIn = false
                                break
                            }
                        }
                        if (isIn) {
                            includedOptions.push(key)
                            break
                        }
                    }
                }
            }
        }
    }
</script>

<div class="imageholder">
    <div
        class="image"
        bind:this="{imagePosition}"
        on:mousemove="{handleMousemove}"
        on:click="{() => {
            if (!activeImage) activeImage = product?.images?.length && product.images[0]
            gallery = product?.images
        }}"
    >
        <img src="{image}" {alt} />
        <div class="zoomimg">
            <img
                src="{image + '?filter=xl'}"
                {alt}
                style="top:-{mousePosition.y * 3}px; left:-{mousePosition.x * 3}px;"
            />
        </div>
    </div>
    <div class="overlay">
        <div class="left">
            {#if activeColor}
                <div
                    class="color"
                    on:click="{() => {
                        if (typeof $openRalChooserOverlay == 'function') {
                            $openRalChooserOverlay()
                        }
                    }}"
                >
                    <div class="colorbox" style="background-color: {activeColor?.HEX}"></div>
                    <span class="text">RAL {activeColor?.RAL}{quboMatt}</span>
                </div>
            {/if}
            {#if activeOptions?.length || includedOptions?.length}
                <div class="options">
                    {#each includedOptions.concat(activeOptions || []) as o}
                        <div
                            class="option"
                            on:mouseover="{() => {
                                tooltip_active[o] = true
                            }}"
                            on:mouseleave="{() => {
                                tooltip_active[o] = false
                            }}"
                            on:click="{openOChooser}"
                            on:focus="{() => {}}"
                        >
                            <img src="{optionsConf[o]?.icon}" alt="{optionsConf[o]?.title}" />
                            {#if tooltip_active[o]}
                                <Tooltip style="top" text="{optionsConf[o]?.title}" />
                            {/if}
                        </div>
                    {/each}
                </div>
            {/if}
        </div>
        <div class="right">
            <div
                class="searchbutton"
                on:click="{() => {
                    if (!activeImage) activeImage = product?.images?.length && product.images[0]
                    gallery = product?.images
                }}"
            >
                <MagnifyIcon size="24px" />
            </div>
        </div>
    </div>
</div>

<LightboxGallery bind:activeImage bind:gallery />

<style lang="less">
    @import "../../css/variables.less";
    .imageholder {
        width: 100%;
        height: 430px;
        order: 2;
        margin-bottom: 20px;
        @media (max-width: 1650px) {
            order: 1;
            height: 430px;
        }
        @media (max-width: 1450px) {
            order: 1;
            height: 410px;
        }
        @media (max-width: 1200px) {
            order: 1;
            margin-bottom: 10px;
            height: 400px;
        }
        @media (max-width: 768px) {
            height: 350px;
        }
        @media (max-width: 650px) {
            height: 250px;
        }
        .image {
            background: var(--surface);
            width: 100%;
            height: calc(~"100% - 50px");
            position: relative;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
            .searchbutton {
                position: absolute;
                bottom: 0px;
                right: 0px;
                padding: 10px;
                line-height: 1;
                // cursor: pointer;
                .flex();
                align-items: center;
                justify-content: center;
                .transition();
            }
            .zoomimg {
                transition: all 0.3s;
                opacity: 0;
                visibility: hidden;
                background: var(--surface);
                position: absolute;
                top: 0;
                left: 0px;
                bottom: 0;
                right: 0px;
                img {
                    position: absolute;
                    width: 400%;
                    height: auto;
                    top: 0;
                    left: 0;
                }
            }
            &:hover {
                cursor: crosshair;
                > .zoomimg {
                    opacity: 1;
                    visibility: visible;
                }
            }
        }
        .overlay {
            background: var(--surface);
            position: relative;
            height: 50px;
            padding: 10px;
            line-height: 1;
            // cursor: pointer;
            .flex();
            align-items: center;
            justify-content: space-between;
            .left {
                .flex();
                align-items: center;
                justify-content: center;
            }
            .options {
                .flex();
                @media (max-width: 768px) {
                    margin-left: 0px;
                }
                .option {
                    position: relative;
                    margin-right: 10px;
                    img {
                        width: 30px;
                        height: 100%;
                        display: inline-block;
                    }
                }
            }
            .text {
                @media (max-width: 1024px) {
                    font-size: 0.8rem;
                }
                @media (max-width: 768px) {
                    display: none;
                }
            }
            .color {
                margin-right: 30px;
                .flex();
                align-items: center;
                .colorbox {
                    width: 30px;
                    height: 30px;
                    margin-right: 10px;
                }
            }
        }
    }
</style>
